export const themeSpacing = { spacing: (factor) => `${0.25 * factor}rem` }
